import { render, staticRenderFns } from "./StickyHeaders.vue?vue&type=template&id=d97164e4"
import script from "./StickyHeaders.vue?vue&type=script&lang=js"
export * from "./StickyHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports